:host {
  color: var(--pine-color-text-message);
  font: var(--pine-typography-body-medium);
}
